import UserService from './UserService';

export class AuthService {
    UserManager;

    constructor({authority, baseUrl, clientId, logoutUri}) {
        this.UserManager = UserService.createUserManager({authority, baseUrl, clientId, logoutUri});
    }

    signinRedirectCallback = () => {
        this.UserManager.signinRedirectCallback().then(() => {
            var originUrl = window.sessionStorage.getItem('oidc-origin');
            sessionStorage.removeItem('oidc-origin');

            window.location.replace(originUrl);
        })
    };

    signinRedirect = () => {
        window.sessionStorage.setItem('oidc-origin', window.location);
        this.UserManager.signinRedirect({});
    };

    isAuthenticated = async () => {
        let user = await this.UserManager.getUser();
        return !!user && !!user.access_token;
    };

    getAccessToken = async () => {
        let user = await this.getUser();
        return user.access_token;
    }

    getUser = async () => {
        let user = await this.UserManager.getUser();

        if (!user || !user.access_token || user.expired) 
        {
            try {
                user = await this.UserManager.signinSilent();
            }
            catch (e) {
                if (e && e.message === 'login_required')
                {
                    this.signinRedirect();
                    return null;
                }

                throw e;
            }
        }

        return user;
    }

    signinSilentCallback = () => {
        this.UserManager.signinSilentCallback();
    };

    logout = () => {
        this.UserManager.signoutRedirect();
    };

    signoutRedirectCallback = () => {
        this.UserManager.signoutRedirectCallback().then(() => {
            this.UserManager.clearStaleState();
        });
    };

    onSilentRenewError = (fn) => {
        this.UserManager.events.addSilentRenewError((e) => {
            fn(e);
        });
    }
}

export default AuthService;